import Typography from '@mui/material/Typography';
import { Avatar, Box } from '@mui/material';

interface Props {
    imgUrl: string;
    title: string;
    description: string;
    haveLink: boolean;
    boxStyle: object;
    index: number;
    iconWidthHeight: any;
    btn?: boolean;
    bigTitle?: boolean;
}

export default function ArsCard({ imgUrl, title, description, haveLink, boxStyle, index, iconWidthHeight, btn, bigTitle }: Props) {

    return (
        <Box component={'div'} sx={boxStyle}>
            <Box>
                <Avatar alt={title} src={imgUrl} sx={iconWidthHeight} />
            </Box>
            <Box> <Typography variant={bigTitle ? "h4" : "h6"} textAlign='center' sx={{ p: 2 }} >

                <strong>{title}</strong></Typography></Box>
            <Box sx={{ height: 130, overflow:'hidden' }}>
                 <Typography variant="body2" textAlign='center' fontSize={16} sx={{ lineHeight: 1.6 }}>
                {description}
            </Typography>
            </Box>
        </Box>
    );
}
